<div
    class="product-menu"
    *ngIf="showProductMenu || enterProductMenu"
    (mouseenter)="mouseenter($event)"
    (mouseleave)="mouseleave($event)"
    [ngStyle]="{ left: isExpanded ? '249.25px' : '57.25px' }"
>
    <div class="product-menu-header">Your Apps</div>
    <div class="incentivecomp">
        <profile-picture class="avatar" [size]="26" [name]="'Incentive Compensation'">
        </profile-picture>
        <a href="{{ compensafeUrl }}">Incentive Compensation</a>
    </div>
    <div class="simplenexus">
        <profile-picture class="avatar" [size]="26" [name]="'M T'"> </profile-picture>
        <a href="{{ usMorgageUrl }}">US Mortgage</a>
    </div>
</div>
